import React, { useContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import './css/Products1.css';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import BannerComponent from '../../uiElements/storeComponents/bannerComponent/BannerComponent';
import { context } from '../../../globalState/GlobalState';
import ProductThumbnail1 from '../../uiElements/productThumbnails/productThumbnail1/ProductThumbnail1';
import { DEFAULT_RIBBONS, getStoreTitle, showProducts } from '../../../catalog/Store';
import { isValidString } from '../../../catalog/Validity';
import { getStoreImage, getStoreMobileImage } from '../../../catalog/Website';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import FeaturedProducts3 from './FeaturedProducts3';

const initialState = {
    selectedRibbon: 'ALL',
};

function reducer(state, action) {
    switch (action.type) {
        case 'setSelectedRibbon':
            return { ...state, selectedRibbon: action.selectedRibbon };
        default:
            return initialState;
    }
}

const Products1 = (props) => {
    const { products, loadingSpinner } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);

    const getProductRibbons = () => {
        if (!showProducts(globalState, products)) {
            return [];
        }
        let ribbons = ['ALL'];
        products.forEach((product) => {
            ribbons = ribbons.concat(product.ribbons);
        });
        return Array.from(new Set(ribbons)).map((ribbon) => {
            return { id: ribbon, title: DEFAULT_RIBBONS[ribbon] };
        });
    };

    const getFeaturedProducts = () => {
        const featuredProducts = products.filter((product) => {
            return product.featureProduct && !product.deleted && product.published && !product.archived;
        });
        if (!showProducts(globalState, featuredProducts)) {
            return [];
        }
        return products.filter((product) => {
            return product.featureProduct && !product.deleted && product.published && !product.archived;
        });
    };

    const getOtherProducts = () => {
        let otherProducts = [];

        if (state.selectedRibbon === 'ALL') {
            otherProducts = products.filter((product) => {
                return !product.deleted && product.published && !product.archived;
            });
        } else {
            otherProducts = products.filter((product) => {
                return product.ribbons.includes(state.selectedRibbon) && !product.deleted && product.published && !product.archived;
            });
        }

        if (!showProducts(globalState, otherProducts)) {
            return [];
        }

        return otherProducts;
    };

    return (
        <>
            {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                <>
                    <div className="products1-container-container">
                        {isValidString(getStoreImage(globalState, false)) ? (
                            <div className="products1-feature-image-container desktop">
                                <img src={getStoreImage(globalState, false)} alt="store" />
                            </div>
                        ) : null}
                        {isValidString(getStoreMobileImage(globalState, false)) ? (
                            <div className="products1-feature-image-container mobile">
                                <img src={getStoreMobileImage(globalState, false)} alt="store" />
                            </div>
                        ) : null}
                        {getFeaturedProducts().length > 0 ? (
                            <div className="products1-featured">
                                <FeaturedProducts3 products={getFeaturedProducts()} />
                            </div>
                        ) : null}
                        <div className="products1-store-container">
                            <div className="products1-store-drawer">
                                <p className="products1-store-label">{getStoreTitle(globalState)}</p>
                                <img className="products1-store-logo" src={globalState.logo.logo2} alt="logo" />
                                <div className="products1-tags">
                                    {getProductRibbons().map((ribbon) => {
                                        return (
                                            <div key={ribbon.id} className={`products1-tag ${state.selectedRibbon === ribbon.id ? 'products1-tag-selected' : ''}`} onClick={() => { setState({ type: 'setSelectedRibbon', selectedRibbon: ribbon.id }); }}>
                                                <p className="products1-tag-name">{ribbon.title}</p>
                                                <ChevronRightIcon className="products1-tag-hide" />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="products1-store">
                                <div className="products1-store-product-banner">
                                    <BannerComponent text="Buy Tickets" buttonText="Buy Tickets" navLink="/tickets" flipped fullWidth={false} tickets />
                                </div>
                                <p className="products1-store-name">{getStoreTitle(globalState)}</p>
                                {getOtherProducts().length > 0 ? (
                                    <div className="products1-products">
                                        {
                                            getOtherProducts().map((product) => {
                                                return (
                                                    <React.Fragment key={product.id}>
                                                        <ProductThumbnail1 product={product} />
                                                    </React.Fragment>
                                                );
                                            })
                                        }
                                    </div>
                                ) : <p className="schedule1-games-unavailable-text alegreya-font-family font-weight-800 font-size-4xl full-width text-center-align m-t-100px text-uppercase">Products unavailable at the moment</p>}
                            </div>
                        </div>
                    </div>

                </>
            )}
        </>
    );
};

Products1.propTypes = {
    products: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default Products1;
